<!--内容-->
<template>
	<div class="mark-content" @mousedown="rightKeyDown($event)">
		<div class="is-typical" v-if="isTypical"></div>
		<operate-bar
			v-show="!isFullNav"
			:studentId="basicInfo.studentId"
			:type="query.type"
			:miniScaleState="miniScaleState"
			@scalePaper="scalePaper"
			@lessenPaper="lessenPaper"
			@scalePage="scalePage"
			@lessenPage="lessenPage"
			@setDifficultPaper="setDifficultPaper"
			@setTypical="setTypical"
			@flushPaper="flushPaper"
		/>
		<!--     疑难卷 或者典型卷-->
		<puzzle-difficult v-model="puzzleBoxState" v-if="puzzleBoxState" :paperType="setPaperType" @confirmPuzzleDiff="confirmPuzzleDiff" />
		<!--    如果是完成状态-->
		<div v-if="isComplete && !isHistoryState" class="complete-paper"></div>
		<!--全屏-->
		<div class="content" ref="content" style="overflow:scroll;" :class="isFullNav ? 'content-max-height' : 'content-min-height'">
			<div class="img-wrap">
				<vue-drag-resize :x="10" :y="70" :w="1" :h="1" :isActive="false" :isResizable="false" :parent="true" ref="drags">
					<img
						:src="canvasImg"
						class="ope-img"
						id="opeImg"
						ref="board"
						:scaleState="scaleState"
						@click="handleFastClick($event)"
						v-show="isShowImg"
					/>
				</vue-drag-resize>
			</div>
		</div>
	</div>
</template>

<script>
import cookies from '@/utils/cookie'
import { mapActions, mapMutations } from 'vuex'
import VueDragResize from 'vue-drag-resize'

export default {
	name: 'mark-content',
	components: {
		operateBar: () => import('./operate-bar'),
		puzzleDifficult: () => import('./puzzle-difficult'),
		VueDragResize
	},
	data() {
		return {
			//拼接之后的图片
			canvasImg: '',
			//缩放倍数
			scaleNum: 1,
			//基本信息
			basicInfo: {},
			//query
			query: this.$route.query,
			//时间
			startTime: 0,
			//打分list
			scoreList: [],
			//多个打分的时候  正在打分的索引
			currentIndex: 0,
			//快捷打分的方式
			fastScoreKey: '+',
			//快捷打分的值
			fastScoreVal: null,
			//是否快捷打分
			isFastScoreState: false,
			//图片列表
			urlList: [],
			//快捷打分 打分点列表
			imgAddrMarkList: {},
			//是否是历史  状态
			isHistoryState: false,
			//是否是图片水平拼接 横排
			isHorizontalImage: true,
			//是否快捷打分
			isFastClick: false,
			//no use
			isCacheNext: false,
			//no use
			isContentPage: true,
			//疑难卷信息
			puzzledContentToStr: '',
			//疑难卷  状态
			puzzleBoxState: false,
			//阅卷状态  主要是用来检查是否阅卷王朝闻
			progressInfo: [],
			//缩放
			scaleState: 1,
			//状态 见下面------> 1, 2, 3
			stage: 2,
			//是否全屏
			isFullNav: false,
			//loading
			loadingState: false,
			//no user
			isCanScalePage: true,
			//设备信息 pc/mobile
			deviceName: null,
			//图片缩放
			miniScaleState: false,
			//是否完成阅卷
			isComplete: false,
			//阅卷完成 就不显示图片了
			isShowImg: true,
			//no use
			rotateDegree: 0,
			//总分
			totalScore: 0,
			//设置当前试卷是什么试卷  疑难卷  典型卷
			setPaperType: null,
			//是否是典型卷
			isTypical: false,
			handleNum: 1,
			// 缩放
			scalePlusNum: 0,
			//是否记住位置
			posState: true
		}
	},
	watch: {
		canvasImg: {
			handler() {
				if (!this.posState) {
					this.$refs['drags'].left = 10
					this.$refs['drags'].top = 70
				}
			},
			immediate: true,
			deep: true
		}
	},
	mounted() {
		//获取数据
		this.operateStageState(2)
		this.watchCurrentCompEmit()
		this.handleScroll()
	},
	methods: {
		...mapActions('examination/databases', ['set', 'get', 'del']),
		...mapMutations('examination/exam', ['setIsNewPerson']),
		// scroll
		handleScroll() {
			document.onmousewheel = event => {
				this.$nextTick(() => {
					if (
						this.$refs['drags'].$el.offsetTop < 0 &&
						event.wheelDelta < 0 &&
						Math.abs(this.$refs['drags'].$el.offsetTop) + 100 > this.$refs['board'].offsetHeight * this.scaleState
					) {
						return
					}
					this.$refs['drags'].top = this.$refs['drags'].top + event.wheelDelta / 8
				})
			}
		},
		// 监听 eventBus
		watchCurrentCompEmit() {
			this.eventBus.$on('flushData', () => {
				this.stage = this.isCacheNext ? 3 : 2
				this.operateStageState(this.stage)
			})
			this.eventBus.$on('isTypical', cb => {
				this.isTypical = cb.state
				this.setPaperType = null
			})
			this.eventBus.$on('emitScoreList', cb => (this.scoreList = cb))
			this.eventBus.$on('startTime', cb => (this.startTime = cb))
			this.eventBus.$on('emitScoreCurrentIndex', cb => (this.currentIndex = cb))
			this.eventBus.$on('miniScaleState', cb => (this.miniScaleState = cb))
			this.eventBus.$on('imgAddrListInfo', cb => {
				if (Object.keys(cb.imgAddrList).length === 0) {
					this.joinImageByUrl(this.urlList, [])
				}
				this.imgAddrMarkList = cb.imgAddrList
				this.deviceMarkList()
			})
			this.eventBus.$on('changeFastScoreInfo', cb => {
				this.fastScoreKey = cb.key
				this.fastScoreVal = cb.val
				this.deviceMarkList(true)
			})
			this.eventBus.$on('examUrlInfo', cb => {
				this.isShowImg = cb.urls.length !== 0
				this.urlList = cb.urls
				this.deviceMarkList()
			})
			this.eventBus.$on('basicInformation', cb => (this.basicInfo = cb))
			this.eventBus.$on('isHistoryState', cb => (this.isHistoryState = cb))
			this.eventBus.$on('isFastScoreState', cb => (this.isFastScoreState = cb))
			this.eventBus.$on('emitCurrentStepScore', async cb => {
				if (this.isFastScoreState) {
					const pathKey = this.query.markingTaskId + this.scoreList[this.currentIndex].pkId
					const localSel = await this.get({ dbName: 'database', path: 'fastScoreStep.' + pathKey, user: true })
					this.fastScoreVal = 1
					if (cb.stepScore > 0) {
						this.fastScoreVal = cb.stepScore
					} else if (localSel && cb.stepScore === 0) {
						this.fastScoreVal = localSel
					}
				}
			})
			this.eventBus.$on('horizontalChange', cb => {
				this.isHorizontalImage = cb
				if (!this.isHistoryState) {
					this.joinImageByUrl(this.urlList, Object.values(this.imgAddrMarkList).flat(1))
				}
			})
			this.eventBus.$on('isCacheNextData', cb => {
				this.isCacheNext = cb
				if (cb) {
					this.stage = 1
					this.operateStageState(this.stage)
				} else {
					this.del({ dbName: 'database', path: 'nextData', delKey: '', user: true })
					this.stage = 2
				}
			})
			this.eventBus.$on('isFastScoreState', cb => {
				this.isFastClick = cb
				if (!cb) {
					this.imgAddrMarkList = {}
					this.eventBus.$emit('imgAddrListInfo', { imgAddrList: {} })
					this.joinImageByUrl(this.urlList, {})
				} else {
					document.oncontextmenu = () => false
				}
			})
			this.eventBus.$on('historyBoardState', cb => {
				this.isHistoryState = cb
				if (!cb) {
					if (this.isCacheNext) {
						this.stage = 3
					} else {
						this.stage = 2
					}
				}
			})
			this.eventBus.$on('progressInfo', cb => (this.progressInfo = cb.initProgress.split('/')))
			this.eventBus.$on('isFullNav', cb => (this.isFullNav = cb))
			this.eventBus.$on('deviceName', cb => (this.deviceName = cb))
			this.eventBus.$on('examDelFastScore', () => this.delFastScore())
			this.eventBus.$on('changePosState', cb => (this.posState = cb))
		},
		//设备
		deviceMarkList(change = false) {
			let pointList = Object.values(this.imgAddrMarkList).flat(1)
			if (this.deviceName === 'mobile') {
				pointList = []
			}
			if (change) {
				pointList = []
			}
			this.joinImageByUrl(this.urlList, pointList)
		},
		// 设置典型卷
		setTypical() {
			this.setPaperType = 1
			this.puzzleBoxState = true
		},
		// 鼠标右键
		rightKeyDown(event) {
			if (event.button === 2 && this.isFastClick) {
				let type
				if (this.isTypical) {
					type = 1
				} else {
					type = this.query.type
				}
				this.submitScore(type)
			}
		},
		// 操作三个状态的数据
		async operateStageState() {
			if (this.stage === 1) {
				//状态1：只缓存（开启缓存的哪个动作）
				this.getContent().then(responce => {
					this.set({ dbName: 'database', path: 'nextData', value: responce, user: true })
				})
			}
			if (this.stage === 2) {
				//	状态2: 获取数据--> 处理数据（非缓存状态）
				this.getContent().then(resp => {
					this.fixContentData(resp)
				})
			} else if (this.stage === 3) {
				// 状态3: 先获取缓存数据-->操作缓存数据-->然后获取数据-->再把数据缓存进去
				let nextData = await this.get({ dbName: 'database', path: 'nextData', user: true })
				if (this.operateFixContent(nextData)) {
					this.fixContentData(nextData).then(() => {
						if (Number(this.progressInfo[0]) + 1 >= Number(this.progressInfo[1])) {
							this.$confirm('阅卷完成，请返回?', '提示', {
								confirmButtonText: '确定',
								showCancelButton: false,
								type: 'success'
							}).then(() => {
								window.history.go(-1)
							})
							return false
						}
						this.getContent().then(res => {
							this.set({ dbName: 'database', path: 'nextData', value: res, user: true })
						})
					})
				}
			}
		},
		// 获取列表
		async getContent() {
			const params = {
				examId: this.query.examId,
				examSubjectId: this.query.examSubjectId,
				paperTextTaskId: this.query.paperTextTaskId,
				markingTaskId: this.query.markingTaskId,
				type: this.query.type
			}
			return this.$post('marking/phoneMarking', params).then(async res => {
				// console.log('res.data', res.data)
				this.eventBus.$emit('examBaseInfo', res.data)
				this.eventBus.$emit('miniScaleState', false)
				this.eventBus.$emit('allotType', res.data.allotType)
				this.eventBus.$emit('startTime', new Date().getTime())
				this.eventBus.$emit('originStepScore', res.data.textPaperScores[0].stepScore)
				this.eventBus.$emit('emitScoreList', res.data.textPaperScores)
				this.eventBus.$emit('personProgress', {
					markingedCount: res.data.markingedCount,
					markingTaskNum: res.data.markingTaskNum,
					markingSum: res.data.markingSum,
					markingedSum: res.data.markingedSum,
					hardMarkingSum: res.data.hardMarkingSum,
					hardMarkingedSum: res.data.hardMarkingedSum
				})
				cookies.set('arbitramentScore', res.data.arbitramentScore)
				let guide = await this.get({ dbName: 'database', path: 'guide', user: true })
				if ((res.data.examInfo.examRange === 1 || res.data.examInfo.examRange === 2) && !guide) {
					this.setIsNewPerson(true)
				}
				this.isShowImg = true
				this.isShowImg = res.data.urls.length !== 0
				if ((res.msg === '您分配的阅卷任务已完成，请阅下一题块。' || res.msg === '请阅下一题块;') && res.code === '201') {
					this.isComplete = true
				}
				return res
			})
		},
		// 操作缓存的数据  或 数据
		async fixContentData(res) {
			this.operateFixContent(res)
			this.imgAddrMarkList = {}
			this.urlList = res.data.urls
			this.joinImageByUrl(this.urlList, [])
			this.basicInfo = res.data
			this.basicInfo.examAnswerMarkingId = 0
			res.data.textPaperScores.forEach((resp, index) => {
				resp.getScore = null
				if (this.isHistoryState) {
					resp.getScore = resp.score
				}
				// 如果是快捷打分状态
				if (this.isFastClick && !this.isHistoryState && index === 0) {
					if (this.fastScoreKey === '+') {
						resp.getScore = 0
					} else if (this.fastScoreKey === '-') {
						resp.getScore = resp.score
					}
				} else {
					resp.getScore = null
				}
			})
			this.eventBus.$emit('emitScoreList', this.basicInfo.textPaperScores)
			this.eventBus.$emit('emitCurrentStepScore', res.data.textPaperScores[0])
			this.eventBus.$emit('imgAddrListInfo', { imgAddrList: this.imgAddrMarkList })
			this.eventBus.$emit('basicInformation', this.basicInfo)
		},
		// 对获取列表的返回值做操作
		operateFixContent(res) {
			return !(res.code === '201' || res.code === '202' || res.code === '203')
		},
		// 快捷打分
		handleFastClick(event) {
			if (this.isComplete && !this.isHistoryState) return false
			this.maxCurrentIndex()
			if (this.isFastClick) {
				if (!this.fastScoreKey || !this.fastScoreVal) return false
				if (this.fastScoreKey === '+' && this.scoreList[this.currentIndex].getScore >= this.scoreList[this.currentIndex].score) {
					return false
				}
				if (this.fastScoreKey === '-' && this.scoreList[this.currentIndex].getScore === 0) {
					return false
				}

				// let yPos = (event.clientY - event.target.getBoundingClientRect().y) / this.scaleState
				let xPos = event.offsetX / this.scaleState
				let yPos = event.offsetY / this.scaleState
				if (!this.imgAddrMarkList[`active${this.currentIndex}`]) this.imgAddrMarkList[`active${this.currentIndex}`] = []
				this.imgAddrMarkList[`active${this.currentIndex}`].push([xPos, yPos, this.fastScoreKey + this.fastScoreVal])

				let positionList = Object.values(this.imgAddrMarkList).flat(1)
				if (positionList.length > 1) {
					let lastArr = positionList.at(-1)
					for (let i = 0; i < positionList.length - 1; i++) {
						if (lastArr[0] >= positionList[i][0] - 5 && lastArr[0] <= positionList[i][0] + 5) {
							positionList[positionList.length - 1][0] = lastArr[0] + 30
							positionList[positionList.length - 1][1] = lastArr[1] + 30
						}
					}
				}
				this.joinImageByUrl(this.urlList, positionList)
				this.eventBus.$emit('miniScaleState', false)
				this.eventBus.$emit('fastScoreHandleMark', { scoreState: this.fastScoreKey, scoreNum: Number(this.fastScoreVal) }) // 用来设置输入框的输入值
				this.eventBus.$emit('imgAddrListInfo', { imgAddrList: this.imgAddrMarkList })
			}
		},
		maxCurrentIndex() {
			if (this.currentIndex >= this.scoreList.length - 1) this.currentIndex = this.scoreList.length - 1
		},
		// 删除快捷打分
		delFastScore() {
			if (this.fastScoreKey === '+') {
				this.scoreList[this.currentIndex].getScore =
					Number(this.scoreList[this.currentIndex].getScore) - Number(this.fastScoreVal) <= 0
						? 0
						: Number(this.scoreList[this.currentIndex].getScore) - Number(this.fastScoreVal)
			} else if (this.fastScoreKey === '-') {
				this.scoreList[this.currentIndex].getScore =
					Number(this.scoreList[this.currentIndex].getScore) + Number(this.fastScoreVal) >= this.scoreList[this.currentIndex].score
						? this.scoreList[this.currentIndex].score
						: Number(this.scoreList[this.currentIndex].getScore) + Number(this.fastScoreVal)
			}
			this.eventBus.$emit('emitScoreList', this.scoreList)
			this.imgAddrMarkList[`active${this.currentIndex}`]?.pop()
			if (this.imgAddrMarkList[`active${this.currentIndex}`] && this.imgAddrMarkList[`active${this.currentIndex}`].length === 0) {
				this.$delete(this.imgAddrMarkList, `active${this.currentIndex}`)
			}
			let positionList = Object.values(this.imgAddrMarkList).flat(1)
			this.joinImageByUrl(this.urlList, positionList)
		},

		// 图片
		joinImageByUrl(urls, positionList, isShowMessage = false) {
			if (!urls.length) {
				this.canvasImg = ''
				return
			}
			this.getTotalScore()
			const _this = this
			import('../utils/handle-img').then(res => {
				res.combineImageByUrl(urls, positionList, _this.isHorizontalImage, function(val) {
					if (JSON.stringify(val) == '{}' || !val.img.length) {
						_this.canvasImg = ''
						return
					}
					_this.canvasImg = val.img
					if (_this.handleNum === 1 && val.width) {
						_this.handleNum += 1
						let contentWidth = _this.$refs['content'].offsetWidth
						let imgWidth = val.width
						if (imgWidth && imgWidth > contentWidth) {
							_this.scaleNum = (contentWidth - 350) / imgWidth
							_this.scaleOperateFastClick()
						}
					}
				})
				this.scaleState = _this.scaleNum * 0.75 + _this.scalePlusNum
				this.scaleMinePaper()
			})
			if (isShowMessage) {
				_this.$message.success('刷新试卷切块图片成功')
			}
		},

		//阅卷顶部-放大图片
		scalePaper() {
			this.scaleState += 0.05
			this.scalePlusNum += 0.05
			this.scaleMinePaper()
		},
		//阅卷顶部-缩小图片
		lessenPaper() {
			if (this.scaleState - 0.05 <= 0.2) {
				this.scaleState = 0.2
			} else {
				this.scaleState -= 0.05
				this.scalePlusNum -= 0.05
			}
			this.scaleMinePaper()
		},
		//快捷打分情况下 缩放图片
		scaleOperateFastClick() {
			this.joinImageByUrl(this.urlList, [])
			if (this.isFastClick) {
				this.imgAddrMarkList = {}
				this.eventBus.$emit('imgAddrListInfo', { imgAddrList: {} })
				this.scoreList.forEach(res => {
					let getScore = 0
					if (this.fastScoreKey === '-') getScore = res.score
					res.getScore = getScore
				})
				this.eventBus.$emit('emitScoreList', this.scoreList)
			}
		},
		// 扩大试卷切图
		scalePage() {
			this.miniScaleState = !this.miniScaleState
			this.eventBus.$emit('miniScaleState', this.miniScaleState)
			this.scaleOrMiniPaper(10)
		},
		// 恢复试卷切图
		lessenPage() {
			this.miniScaleState = !this.miniScaleState
			this.eventBus.$emit('miniScaleState', this.miniScaleState)
			this.scaleOrMiniPaper(0)
		},
		// 刷新试卷切块
		flushPaper() {
			this.imgAddrMarkList = {}
			this.eventBus.$emit('imgAddrListInfo', { imgAddrList: {} })
			this.scoreList.forEach(res => (res.getScore = null))
			this.scoreList[0].getScore = 0
			this.eventBus.$emit('emitScoreList', this.scoreList)
			this.joinImageByUrl(this.urlList, [], true)
			this.scaleMinePaper()
		},
		//图片缩放
		scaleMinePaper() {
			this.$nextTick(() => {
				if (!this.$refs['board']) {
					this.canvasImg = ''
					return
				}
				this.$refs['board'].style.transform = `rotate(${this.rotateDegree}deg)`
				this.$refs['board'].style.zoom = `${this.scaleState * 100}%`
				this.$refs['board'].style.transformOrigin = '0 0'
			})
		},
		//图片缩放
		scaleOrMiniPaper(expand) {
			if (!this.isCanScalePage) {
				this.$message({ type: 'error', message: '操作过于频繁', duration: 3000 })
				return false
			}
			this.scoreList.forEach(res => (res.getScore = null))
			this.scoreList[0].getScore = 0
			this.eventBus.$emit('emitScoreList', this.scoreList)
			this.eventBus.$emit('imgAddrListInfo', { imgAddrList: {} })
			this.eventBus.$emit('emitScoreCurrentIndex', 0)
			const params = {
				expand: expand,
				examId: this.query.examId,
				examSubjectId: this.query.examSubjectId,
				studentId: this.basicInfo.studentId,
				paperTextTaskId: this.query.paperTextTaskId
			}
			const self = this
			this.isCanScalePage = false
			this.$post('marking/expandPaper', params).then(res => {
				this.joinImageByUrl(res.data, [])
				setTimeout(() => {
					self.isCanScalePage = true
				}, 500)
			})
		},
		//	疑难卷 icon
		setDifficultPaper() {
			if (Number(this.basicInfo.studentId) < 0) {
				this.$message({ type: 'error', message: '暂无试卷，不能标记为疑难卷' })
				return false
			}
			this.setPaperType = -2
			this.puzzleBoxState = true
		},
		// // 疑难卷 确定 btn
		confirmPuzzleDiff(val) {
			this.puzzledContentToStr = val
			this.setDifficult()
		},
		// 获取总分
		getTotalScore() {
			if (this.scoreList && this.scoreList.length > 0) {
				this.totalScore = 0
				let temporyVar = 0
				this.scoreList.forEach(res => {
					temporyVar += Number(res.getScore) || 0
				})
				this.totalScore = temporyVar
			}
		},
		// 设置疑难卷 典型卷 确定
		setDifficult() {
			if (this.loadingState) return false
			if (this.setPaperType === 1) {
				this.isTypical = true
				this.puzzleBoxState = false
				this.eventBus.$emit('isTypical', { state: true, text: this.puzzledContentToStr })
				return false
			}
			this.loadingState = true
			this.eventBus.$emit('isDisableSubmitBtn', true)
			this.submitScore(this.setPaperType)
		},
		// 打分之后提交分数
		submitScore(type) {
			const self = this
			import('../utils/help').then(resp => {
				const duration = new Date().getTime() - this.startTime
				if (Number(this.basicInfo.studentId) < 0) {
					this.$message({ type: 'error', message: '暂无试卷', duration: 3000 })
					this.loadingState = false
					this.eventBus.$emit('isDisableSubmitBtn', false)
					return false
				}
				resp.submitScore(
					this,
					this.query,
					this.scoreList,
					this.basicInfo,
					this.imgAddrMarkList,
					duration,
					type,
					this.isFastClick,
					this.isHorizontalImage,
					this.puzzledContentToStr
				).then(val => {
					if (val.code === '200') {
						if (self.setPaperType === -2 || self.setPaperType === 1) {
							this.puzzleBoxState = false
							this.puzzledContent = []
							this.puzzleActiveIndex = []
							this.puzzledContentToStr = ''
							this.$message({
								type: 'success',
								message: `${self.setPaperType === 1 ? '典型' : '疑难'}卷设置成功`,
								duration: 3000
							})
						} else {
							this.$bigScore({ score: this.totalScore, dom: this.$parent.$refs['home'] })
						}
						this.eventBus.$emit('isHistoryState', false)
						if (this.isFastClick) {
							this.eventBus.$emit('isShowAutoSubmit', false)
						} else {
							this.eventBus.$emit('isShowAutoSubmit', true)
						}
						this.operateStageState(2)
						setTimeout(() => {
							self.loadingState = false
							self.eventBus.$emit('isDisableSubmitBtn', false)
						}, 500)
					}
				})
			})
		}
	}
}
</script>

<style scoped lang="less">
.mark-content {
	width: 100%;
	height: 100%;
	background: #cbeade;
	z-index: -10;
	box-shadow: 0 0 10px rgb(185, 180, 180);

	.difficult-box {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 100;
		background: rgba(0, 0, 0, 0.7);
		display: flex;
		justify-content: center;
		align-items: center;
		box-shadow: 0 0 10px #b9b4b4;

		.difficult-content {
			width: 500px;
			background: white;
			padding: 15px;
			border-radius: 10px;
		}

		.content {
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			flex-wrap: wrap;
		}

		.list {
			width: 240px;
			height: 50px;
			line-height: 50px;
			font-size: 17px;
			color: black;
			text-align: center;
			background: #cbeade;
			border-radius: 12px;
			margin-bottom: 20px;

			&:hover {
				cursor: pointer;
			}

			&:nth-child(2n + 1) {
				margin-right: 20px;
			}
		}

		.list-active {
			background: #009688;
			color: white;
		}

		.btn-box {
			margin-top: 20px;
			display: flex;
			justify-content: center;
		}
	}

	.content {
		overflow: auto;
		width: 100%;
		height: 100%;

		.img-wrap {
			margin: 0 auto;
			padding: 5px 0 0 5px;
			box-sizing: border-box;

			img {
				cursor: pointer;
			}
		}
	}

	.content-max-height {
		height: 100%;
	}

	.content-min-height {
		height: calc(100% - 50px);
	}

	.complete-paper {
		position: absolute;
		top: 0;
		right: 20px;
		width: 240px;
		height: 220px;
		border-radius: 50%;
		background: url('../../../assets/image/over.jpg') no-repeat;
		background-size: 100% 100%;
		z-index: 20;
	}

	.is-typical {
		position: absolute;
		top: 50px;
		left: 10px;
		width: 110px;
		height: 100px;
		border-radius: 50%;
		opacity: 0.3;
		background: url('../../../assets/image/typical.jpg') no-repeat;
		background-size: 100% 100%;
		z-index: 20;
	}

	.ope-img {
		border: 2px solid #ff7171;
		border-radius: 6px;
	}

	/deep/ .vdr-stick {
		display: none;
	}
}
</style>
